/**
 * Tealium Analytics Event Names
 * Centralized constants for all analytics tracking events
 */

// Base event prefix
const EVENT_PREFIX = 'CIP';
const REGISTRATION_PREFIX = `${EVENT_PREFIX} - Registration`;

// Registration Events
export const TEALIUM_EVENTS = {
  REGISTRATION: {
    START: `${REGISTRATION_PREFIX} - Start`,
    SUBMIT: `${REGISTRATION_PREFIX} - Submit`,
    SUCCESS: `${REGISTRATION_PREFIX} - Success`,
    ERROR: `${REGISTRATION_PREFIX} - Error`,
    VALIDATION_FAILED: `${REGISTRATION_PREFIX} - Validation Failed`,
    DUPLICATE_IDENTITY: `${REGISTRATION_PREFIX} - Error - Duplicate Identity`,
    TIMEOUT: `${REGISTRATION_PREFIX} - Time Out`
  },
  
  USER: {
    LOGGED_IN: `${EVENT_PREFIX}-User-LoggedIn`
  },

  CLAIM_SEARCH: {
    INFO: `${EVENT_PREFIX}-Claim-Search-Info`
  },

  APPRAISAL: {
    CANCEL_APPOINTMENT: `${EVENT_PREFIX} - Cancel Appointment`,
    VIEW_DOCUMENT: `${EVENT_PREFIX}-View-Appraisal-Document`
  },

  QUICK_ACCESS: {
    CLAIM_SEARCH: `${EVENT_PREFIX}-QuickAccess-ClaimSearch`
  }
} as const;
